import {
  BrowserRouter as Router,
  Routes,
  Route,
  Link,
} from "react-router-dom";

import {
  SignedIn,
  SignedOut,
  SignInButton,
  SignUpButton,
  UserButton,
} from "@clerk/clerk-react";

import Landing from "./Landing";

import PlaidConnect from "./PlaidConnect";
import Transactions from "./Transactions";
import DisconnectBank from "./DisconnectBank";

import Privacy from "./Privacy";
import Terms from "./Terms";
import DataPolicy from "./DataPolicy";

/* Home page */
function Home() {
  return (
    <div className="space-y-6">
      <h1 className="text-lg font-semibold tracking-tight">
        Dashboard
      </h1>

      <SignedOut>
        <p className="text-gray-600">
          Please sign in to connect your bank account.
        </p>
      </SignedOut>

      <SignedIn>
        <PlaidConnect />
        <Transactions />
        <DisconnectBank />
      </SignedIn>
    </div>
  );
}


export default function App() {
  return (
    <Router>
      {/* Header */}
      <header className="bg-white border-b">
        <nav className="max-w-5xl mx-auto px-6 py-4 flex items-center gap-6">
          <Link className="font-medium text-gray-900" to="/">
            Home
          </Link>

          <div className="ml-auto flex items-center gap-3">
            <SignedOut>
              <SignInButton />
              <SignUpButton />
            </SignedOut>

            <SignedIn>
              <UserButton />
            </SignedIn>
          </div>
        </nav>
      </header>

      {/* 👇 MAIN CONTENT AREA */}
      <Routes>
  {/* Landing page (FULL BLEED) */}
  <Route
    path="/"
    element={
      <>
        <SignedOut>
          <Landing />
        </SignedOut>

        <SignedIn>
          <main className="max-w-5xl mx-auto px-6 py-10 space-y-8">
            <Home />
          </main>
        </SignedIn>
      </>
    }
  />

  {/* Legal pages */}
  <Route
    path="/privacy"
    element={
      <main className="max-w-5xl mx-auto px-6 py-10">
        <Privacy />
      </main>
    }
  />
  <Route
    path="/terms"
    element={
      <main className="max-w-5xl mx-auto px-6 py-10">
        <Terms />
      </main>
    }
  />
  <Route
    path="/data"
    element={
      <main className="max-w-5xl mx-auto px-6 py-10">
        <DataPolicy />
      </main>
    }
  />
</Routes>


<footer className="border-t mt-16">
  <div className="max-w-5xl mx-auto px-6 py-6 flex flex-col sm:flex-row items-center justify-between text-sm text-gray-500 gap-4">
    <span>© {new Date().getFullYear()} Ackount</span>

    <nav className="flex gap-6">
      <Link
        to="/privacy"
        className="hover:text-gray-900"
      >
        Privacy
      </Link>
      <Link
        to="/terms"
        className="hover:text-gray-900"
      >
        Terms
      </Link>
      <Link
        to="/data"
        className="hover:text-gray-900"
      >
        Your Data
      </Link>
    </nav>
  </div>
</footer>



    </Router>
  );
}

